import { PLANO_ANUAL, PLANO_SEMESTRAL, PLANO_TRIMESTRAL, PLANO_MENSAL } from '../../../constants'
import { formatValor } from '../../../utils/formatter/formatter'

export const getLinks = ( infosPagamento, plano ) => {
  const parcelasTipoPlanoDict = {
    [ PLANO_ANUAL.visualizacao ]: PLANO_ANUAL.parcelas,
    [ PLANO_SEMESTRAL.visualizacao ]: PLANO_SEMESTRAL.parcelas,
    [ PLANO_TRIMESTRAL.visualizacao ]: PLANO_TRIMESTRAL.parcelas,
    [ PLANO_MENSAL.visualizacao ]: PLANO_MENSAL.parcelas,
  }
  const valorFrete = infosPagamento.valorFrete / parcelasTipoPlanoDict[ infosPagamento.tipoPlano ]
  const valor = formatValor( { 'valor': infosPagamento.valorKit + valorFrete } )
  const array = [
    {
      'route': 'trocar-forma-pagamento',
      'subtitle': `Você pode efetuar o pagamento com seu cartão de crédito. A cobrança passa a ser mensal, no valor de ${valor} por mês.`,
      'title': 'Trocar forma de pagamento'
    }
  ]

  if ( !infosPagamento.hasPagamentoPendente ) {
    let itemBoleto

    if ( !infosPagamento.boletoPago && !infosPagamento.boletoVencido && infosPagamento.urlBoleto ) {
      itemBoleto = {
        'linkExterno': true,
        'route': `${infosPagamento.urlBoleto}`,
        'subtitle': 'Obtenha o boleto pendente para efetuar o pagamento.',
        'title': 'Ver boleto'
      }
    }

    array.splice( 0, 0, itemBoleto )
  }

  return array
}

export const NOVO_BOLETO = 'Novo Boleto'

export const PAGAMENTO_DO_BOLETO = 'Pagamento do boleto'

export const DESCRICAO_INTERNET_BANKING = 'Copie o código e cole no site/app do seu internet banking.'

export const DESCRICAO_PAGAMENTO_LIBERACAO = 'O seu kit só será enviado após a confirmação pela instituição financeira, que leva em média 3 dias após o pagamento.'

export const VISUALIZAR_BOLETO = 'Visualizar boleto'
